<template>
  <div>
    <form role="form">
      <div class="row">
        <div class="col-md-6" v-if="getMember.my_a_b_f_t_user && getMember.my_a_b_f_t_user.user">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">My ABFT</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="statut">Statut</label>
                    <select id="statut"
                            class="form-control"
                            name="newParticipation[sexe]"
                            v-model="getMember.my_a_b_f_t_user.user.active">
                      <option :value="1"> Activé</option>
                      <option :value="0"> Désactivé</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <b-form-group label="Droits">
                      <div class="checkbox">
                        <label for="read">
                          <input id="read" name="newEntry[read]" type="checkbox"
                                 v-model="getMember.my_a_b_f_t_user.canScanQrCode">
                          Peut scanner les QRCode
                        </label>
                      </div>
                    </b-form-group>
                  </div>
                  <button class="btn btn-primary pull-right m-5  "
                          :disabled="disabledBtnActive"
                          @click.prevent="saveStatut()">
                    Sauvegarder
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="statut">Mot de passe</label>
                  </div>
                  <button class="btn btn-default pull-right"
                          :disabled="disabledBtn"
                          @click.prevent="generateCourrierNewPassword()">
                    Activer MyABFT et générer un nouveau mot de passe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" v-if="getMember.my_a_b_f_t_user && getMember.my_a_b_f_t_user.user">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Définir les accès pour un club</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <div v-if="getClubSelected">
                    <div class="selection-label">
                                    <span class="selection-label_remove" role="presentation"
                                          @click="removeClubSelected()">×</span>
                      {{ getClubSelected.club }}
                    </div>
                  </div>

                  <searchclub ref="searchclub"
                              :limit="5"
                              :min-chars="2"
                  >
                  </searchclub>
                  <br>
                  <br>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <b-form-group label="Droits">
                      <div class="checkbox">
                        <label for="read">
                          <input id="read" name="newEntry[read]" type="checkbox"
                                 v-model="newEntry.read">
                          Droit en lecture
                        </label>
                      </div>
                      <div class="checkbox">
                        <label for="write">
                          <input id="write" name="newEntry[write]" type="checkbox"
                                 v-model="newEntry.write">
                          Droit en écriture
                        </label>
                      </div>
                      <div class="checkbox">
                        <label for="can_register_member">
                          <input id="can_register_member" name="newEntry[can_register_member]" type="checkbox"
                                 v-model="newEntry.can_register_member">
                          Peut enregistrer des membres en ligne (version bêta)
                        </label>
                      </div>
                    </b-form-group>
                  </div>
                  <button class="btn btn-primary pull-right m-5  "
                          :disabled="disabledBtnActive"
                          @click.prevent="addAccess()">
                    Ajouter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12" v-if="getMember.my_a_b_f_t_user && getMember.my_a_b_f_t_user.user">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">({{getMember.my_a_b_f_t_user.myabft_user_club.length}} accès définis)</h3>
            </div>
            <div class="box-body">
              <b-table
                id="tableListingAllUserMyABFT"
                responsive bordered striped hover
                :items="getMember.my_a_b_f_t_user.myabft_user_club"
                :fields="columns"
                :current-page="pagination_meta.current_page"
                :per-page="pagination_meta.per_page"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-compare="sortCompareAdvanced"
                :no-local-sorting="true"
                :no-sort-reset="true"
                :empty-text="'Aucun résultat'"
                :empty-filtered-text="'Aucun résultat'"
                :busy.sync="isBusy"
                foot-clone
                show-empty
              >
                <template slot="user.club" slot-scope="data">
                  <router-link
                    :to="{ name: 'Club', params: { club_id: data.item.club.id }}">
                    {{data.item.club.club }}
                  </router-link>
                </template>

                <template slot="read" slot-scope="data">
                  <div v-if="!isEditing(data.item.id)">
                    {{data.item.read==1 ? 'OUI':'NON'}}
                  </div>
                  <div v-if="isEditing(data.item.id)">
                    <select v-model="getObjectEditable(data.item.id).read">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>
                </template>

                <template slot="write" slot-scope="data">
                  <div v-if="!isEditing(data.item.id)">
                    {{data.item.write==1 ? 'OUI':'NON'}}
                  </div>
                  <div v-if="isEditing(data.item.id)">
                    <select v-model="getObjectEditable(data.item.id).write"
                            @change="getObjectEditable(data.item.id).write==1 ? getObjectEditable(data.item.id).read=1 : '' ">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>

                </template>
                <template slot="can_register_member" slot-scope="data">
                  <div v-if="!isEditing(data.item.id)">
                    {{data.item.can_register_member==1 ? 'OUI':'NON'}}
                  </div>
                  <div v-if="isEditing(data.item.id)">
                    <select v-model="getObjectEditable(data.item.id).can_register_member"
                            @change="getObjectEditable(data.item.id).can_register_member==1 ? getObjectEditable(data.item.id).write=1 : '' ">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>
                </template>

                <template slot="actions" slot-scope="data">
                  <button v-if="!isEditing(data.item.id)"
                          @click.prevent="editItem(data.item.id)"
                          class="btn btn-default padding2">
                    <i class="glyphicon glyphicon-pencil"></i>
                  </button>
                  <button v-if="!isEditing(data.item.id)"
                          @click.prevent="removeInscription(data.item.id)"
                          class="btn btn-default padding2">
                    <i class="glyphicon glyphicon-remove"></i>
                  </button>
                  <button v-if="isEditing(data.item.id)"
                          @click.prevent="validEditing(data.item.id)"
                          class="btn btn-primary padding2">
                    <i class="glyphicon glyphicon-ok"></i>
                  </button>
                  <button v-if="isEditing(data.item.id)"
                          @click.prevent="cancelEditing(data.item.id)"
                          class="btn btn-danger padding2">
                    <i class="glyphicon glyphicon-ban-circle"></i>
                  </button>
                </template>

              </b-table>
              <b-pagination size="md"
                            :total-rows="getMember.my_a_b_f_t_user.myabft_user_club.length"
                            v-model="pagination_meta.current_page"
                            :per-page="pagination_meta.per_page">
              </b-pagination>
            </div>
          </div>
        </div>

        <div class="col-md-12" v-if="!getMember.my_a_b_f_t_user">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">My ABFT</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-primary  m-5  "
                          :disabled="disabledBtnActive"
                          @click.prevent="addAccessToMyABFT()">
                    Ajouter un accès à MyABFT pour ce membre
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {ErrorBag} from 'vee-validate';
  import Datepicker from 'vuejs-datepicker';

  var $ = require('jquery');
  var variables = require('../../../assets/js/variables')
  var _ = require('underscore')
  var moment = require('moment')
  var FileSaver = require('file-saver');

  export default {
    data() {
      return {
        loading: {},
        statutMyABFT: 0,
        disabledBtn: false,
        disabledBtnActive: false,
        sortBy: null,
        sortDesc: null,
        arrayEdits: [],
        isBusy: false,
        newEntry: {},
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 20,
          to: 1,
          total: 1
        },
        columns: [
          {
            label: 'Club',
            key: 'user.club',
            sortable: true,
          },
          {
            label: 'Accès en lecture',
            key: 'read',
            sortable: false,
          },
          {
            label: 'Accès en écriture',
            key: 'write',
            sortable: false,
          },
          {
            label: 'Peut inscrire des membres en ligne',
            key: 'can_register_member',
            sortable: false,
          },
          {
            label: 'Actions',
            key: 'actions',
            sortable: false,
          },
        ]
      }
    },
    computed: {
      ...mapGetters({
        getMember: 'getMember',
        getRoute: 'getRoute',
        getClubSelected: 'getClubSelected',
      }),

    },
    mounted: function () {
      var these = this
      this.$nextTick(function () {
        these.resetNewEntry()
      })
    },
    created() {
    },
    watch: {},
    components: {},
    methods: {
      ...mapActions({
        majClubSelected: "majClubSelected",
        removeClubSelected: "removeClubSelected",
      }),
      addAccessToMyABFT() {
        this.isBusy = true
        this.disabledBtnActive = true
        let self = this;

        this.$http.post(this.getRoute('addMemberToNewUserForMyABFT'),
          {
            id_member: self.getMember.id,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.success("Ajout de l'accès effectué")
            self.getMember.my_a_b_f_t_user = response.body
          }, (response) => {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.error("Ajout de l'accès échoué.")
          });
      },
      addAccess() {
        this.isBusy = true
        this.disabledBtnActive = true
        let self = this;

        this.$http.post(this.getRoute('addRightForClubForMember'),
          {
            id_club: self.getClubSelected.id,
            id_member: self.getMember.id,
            read: self.newEntry.read,
            write: self.newEntry.write,
            can_register_member: self.newEntry.can_register_member,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtnActive = false
            this.removeClubSelected()
            this.resetNewEntry()
            self.$noty.success("Ajout effectué")
            self.getMember.my_a_b_f_t_user = response.body
          }, (response) => {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.error("Ajout échoué. Club déjà présent dans la liste?")
          });
      },
      resetNewEntry: function () {
        this.newEntry = {
          club: {
            id: 0,
            club: ""
          },
          read: 1,
          write: 0,
          can_register_member: 0,
        }
      },
      sortCompareAdvanced: function (a, b, key) {
        if (typeof a[key] === 'number' && typeof b[key] === 'number') {
          // If both compared fields are native numbers
          return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
        } else {
          // Stringify the field data and use String.localeCompare
          return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
            numeric: true
          })
        }
      },

      removeInscription: function (idMyAbftUserClub) {
        this.isBusy = true
        let self = this;
        let item = _.find(this.getMember.my_a_b_f_t_user.myabft_user_club, function (item) {
          return item.id == idMyAbftUserClub;
        });
        this.$http.post(this.getRoute('removeRightForClubForMember'),
          {
            id_club: item.club.id,
            id_myAbftUser: idMyAbftUserClub,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.success("Modification effectuée")
            self.getMember.my_a_b_f_t_user = response.body
            this.arrayEdits = _.reject(this.arrayEdits, function (item) {
              return item.id == idMyAbftUserClub;
            });
          }, (response) => {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.error("Modification échouée")
          });
      },
      validEditing: function (idMyAbftUserClub) {
        this.isBusy = true
        let self = this;
        let item = this.getObjectEditable(idMyAbftUserClub);
        this.$http.put(this.getRoute('updateRightForClub'),
          {
            id_club: item.club.id,
            id_myAbftUser: idMyAbftUserClub,
            read: item.read,
            write: item.write,
            can_register_member: item.can_register_member,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.success("Modification effectuée")
            this.arrayEdits = _.reject(this.arrayEdits, function (item) {
              return item.id == idMyAbftUserClub;
            });
          }, (response) => {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.error("Modification échouée")
          });

      },
      getObjectEditable: function (id) {
        return _.find(this.arrayEdits, function (item) {
          return item.id == id;
        })
      },

      editItem: function (id) {
        let self = this
        let item = _.find(this.getMember.my_a_b_f_t_user.myabft_user_club, function (item) {
          return item.id == id;
        });
        let item2 = _.find(this.arrayEdits, function (item) {
          return item.id == id;
        });
        // debugger
        if (!item2)
          this.arrayEdits.push(item)
      },
      cancelEditing: function (id) {
        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
          return item == id;
        });
      },
      isEditing: function (id) {
        let test = _.find(this.arrayEdits, function (item) {
          return item.id == id;
        })
        return test ? true : false
      },

      saveStatut() {
        this.disabledBtnActive = true
        this.$http.post(this.getRoute('saveStatutMyABFT'),
          {id_member: this.getMember.id, active: this.getMember.my_a_b_f_t_user.user.active, canScanQrCode: this.getMember.my_a_b_f_t_user.canScanQrCode}
        )
          .then((response) => {
            this.$noty.success("Statut sauvegardé!")
            this.disabledBtnActive = false
          }, (response) => {
            this.$noty.error("Erreur dans la sauvegarde du statut")
            this.disabledBtnActive = false
          });
      },
      generateCourrierNewPassword() {
        this.disabledBtn = true
        this.$http.post(this.getRoute('generateCourrierNewPassword'),
          {typeCourrier: "generateCourrierNewPassword", id_member: this.getMember.id},
          {responseType: 'blob'})
          .then((response) => {
            var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
            FileSaver.saveAs(blob, this.getMember.id + "_password.pdf");
            this.disabledBtn = false
            this.getMember.my_a_b_f_t_user.user.active = 1
            return response.blob();
          }, (response) => {
            this.$noty.error("Erreur dans la génération du courrier")
            this.disabledBtn = false
          });
      },
    },
    filters: {
      idFormat: function (value) {
        return new Intl.NumberFormat("de-DE").format(value)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/MyABFTMembre.vue